/* @ngInject */

export default (LevelOption, YesNoOption) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function NeedsAnalysis(risk, goal) {
    this.risk = risk;
    this.goal = goal;

    if (_.isEmpty(this.risk?.natureOfServiceSought)) {
      this.risk.natureOfServiceSought = {
        response: 0,
        assessment: LevelOption.none
      };
    } else {
      switch (this.risk?.natureOfServiceSought?.assessment) {
        case '1':
        case 1:
          this.risk.natureOfServiceSought.assessment = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.natureOfServiceSought.assessment = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.natureOfServiceSought.assessment = LevelOption.high;
          break;
        default:
          this.risk.natureOfServiceSought.assessment = LevelOption.of(
            this.risk?.natureOfServiceSought?.assessment?.name
          );
          break;
      }
    }
    if (_.isEmpty(this.risk?.productRequired)) {
      this.risk.productRequired = {
        response: '',
        assessment: LevelOption.none
      };
    } else {
      switch (this.risk?.productRequired?.assessment) {
        case '1':
        case 1:
          this.risk.productRequired.assessment = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.productRequired.assessment = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.productRequired.assessment = LevelOption.high;
          break;
        default:
          this.risk.productRequired.assessment = LevelOption.of(
            this.risk?.productRequired?.assessment?.name
          );
          break;
      }
    }
    if (_.isEmpty(this.risk?.internationalTradeFacilitiesBeingSought)) {
      this.risk.internationalTradeFacilitiesBeingSought = {
        response: YesNoOption.none,
        assessment: LevelOption.none
      };
    } else {
      switch (this.risk?.internationalTradeFacilitiesBeingSought?.response) {
        case '1':
        case 1:
          this.risk.internationalTradeFacilitiesBeingSought.response = YesNoOption.yes;
          break;
        case '2':
        case 2:
          this.risk.internationalTradeFacilitiesBeingSought.response = YesNoOption.no;
          break;
        default:
          this.risk.internationalTradeFacilitiesBeingSought.response = YesNoOption.of(
            this.risk?.internationalTradeFacilitiesBeingSought?.response?.name
          );
          break;
      }
      switch (this.risk?.internationalTradeFacilitiesBeingSought?.assessment) {
        case '1':
        case 1:
          this.risk.internationalTradeFacilitiesBeingSought.assessment = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.internationalTradeFacilitiesBeingSought.assessment = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.internationalTradeFacilitiesBeingSought.assessment = LevelOption.high;
          break;
        default:
          this.risk.internationalTradeFacilitiesBeingSought.assessment = LevelOption.of(
            this.risk?.internationalTradeFacilitiesBeingSought?.assessment?.name
          );
          break;
      }
    }
    if (_.isEmpty(this.risk?.locationOfUnderlyingAssets)) {
      this.risk.locationOfUnderlyingAssets = {
        response: 0,
        assessment: LevelOption.none
      };
    } else {
      switch (this.risk?.locationOfUnderlyingAssets?.assessment) {
        case '1':
        case 1:
          this.risk.locationOfUnderlyingAssets.assessment = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.locationOfUnderlyingAssets.assessment = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.locationOfUnderlyingAssets.assessment = LevelOption.high;
          break;
        default:
          this.risk.locationOfUnderlyingAssets.assessment = LevelOption.of(
            this.risk?.locationOfUnderlyingAssets?.assessment?.name
          );
          break;
      }
    }
    if (_.isEmpty(this.risk?.locationOfAssetBeingAcquired)) {
      this.risk.locationOfAssetBeingAcquired = {
        response: 0,
        assessment: LevelOption.none
      };
    } else {
      switch (this.risk?.locationOfAssetBeingAcquired?.assessment) {
        case '1':
        case 1:
          this.risk.locationOfAssetBeingAcquired.assessment = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.locationOfAssetBeingAcquired.assessment = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.locationOfAssetBeingAcquired.assessment = LevelOption.high;
          break;
        default:
          this.risk.locationOfAssetBeingAcquired.assessment = LevelOption.of(
            this.risk?.locationOfAssetBeingAcquired?.assessment?.name
          );
          break;
      }
    }
    if (_.isEmpty(this.risk?.locationOfFundsForRepayment)) {
      this.risk.locationOfFundsForRepayment = {
        response: 0,
        assessment: LevelOption.none
      };
    } else {
      switch (this.risk?.locationOfFundsForRepayment?.assessment) {
        case '1':
        case 1:
          this.risk.locationOfFundsForRepayment.assessment = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.locationOfFundsForRepayment.assessment = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.locationOfFundsForRepayment.assessment = LevelOption.high;
          break;
        default:
          this.risk.locationOfFundsForRepayment.assessment = LevelOption.of(
            this.risk?.locationOfFundsForRepayment?.assessment?.name
          );
          break;
      }
    }
    if (_.isEmpty(this.risk?.leadSourcingMethod)) {
      this.risk.leadSourcingMethod = {
        response: 0,
        assessment: LevelOption.none
      };
    } else {
      switch (this.risk?.leadSourcingMethod?.assessment) {
        case '1':
        case 1:
          this.risk.leadSourcingMethod.assessment = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.leadSourcingMethod.assessment = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.leadSourcingMethod.assessment = LevelOption.high;
          break;
        default:
          this.risk.leadSourcingMethod.assessment = LevelOption.of(
            this.risk?.leadSourcingMethod?.assessment?.name
          );
          break;
      }
    }
    if (_.isEmpty(this.risk?.customerIsDemandingRapidAccess)) {
      this.risk.customerIsDemandingRapidAccess = {
        response: YesNoOption.none,
        assessment: LevelOption.none
      };
    } else {
      switch (this.risk?.customerIsDemandingRapidAccess?.response) {
        case '1':
        case 1:
          this.risk.customerIsDemandingRapidAccess.response = YesNoOption.yes;
          break;
        case '2':
        case 2:
          this.risk.customerIsDemandingRapidAccess.response = YesNoOption.no;
          break;
        default:
          this.risk.customerIsDemandingRapidAccess.response = YesNoOption.of(
            this.risk?.customerIsDemandingRapidAccess?.response?.name
          );
          break;
      }
      switch (this.risk?.customerIsDemandingRapidAccess?.assessment) {
        case '1':
        case 1:
          this.risk.customerIsDemandingRapidAccess.assessment = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.customerIsDemandingRapidAccess.assessment = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.customerIsDemandingRapidAccess.assessment = LevelOption.high;
          break;
        default:
          this.risk.customerIsDemandingRapidAccess.assessment = LevelOption.of(
            this.risk?.customerIsDemandingRapidAccess?.assessment?.name
          );
          break;
      }
    }
    if (_.isEmpty(this.risk?.loanRepaymentsComingFromThirdParties)) {
      this.risk.loanRepaymentsComingFromThirdParties = {
        response: YesNoOption.none,
        assessment: LevelOption.none
      };
    } else {
      switch (this.risk?.loanRepaymentsComingFromThirdParties?.response) {
        case '1':
        case 1:
          this.risk.loanRepaymentsComingFromThirdParties.response = YesNoOption.yes;
          break;
        case '2':
        case 2:
          this.risk.loanRepaymentsComingFromThirdParties.response = YesNoOption.no;
          break;
        default:
          this.risk.loanRepaymentsComingFromThirdParties.response = YesNoOption.of(
            this.risk?.loanRepaymentsComingFromThirdParties?.response?.name
          );
          break;
      }
      switch (this.risk?.loanRepaymentsComingFromThirdParties?.assessment) {
        case '1':
        case 1:
          this.risk.loanRepaymentsComingFromThirdParties.assessment = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.loanRepaymentsComingFromThirdParties.assessment = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.loanRepaymentsComingFromThirdParties.assessment = LevelOption.high;
          break;
        default:
          this.risk.loanRepaymentsComingFromThirdParties.assessment = LevelOption.of(
            this.risk?.loanRepaymentsComingFromThirdParties?.assessment?.name
          );
          break;
      }
    }
    if (_.isEmpty(this.risk?.productsSoughtEnableCrossBorderAssetFlows)) {
      this.risk.productsSoughtEnableCrossBorderAssetFlows = {
        response: YesNoOption.none,
        assessment: LevelOption.none
      };
    } else {
      switch (this.risk?.productsSoughtEnableCrossBorderAssetFlows?.response) {
        case '1':
        case 1:
          this.risk.productsSoughtEnableCrossBorderAssetFlows.response = YesNoOption.yes;
          break;
        case '2':
        case 2:
          this.risk.productsSoughtEnableCrossBorderAssetFlows.response = YesNoOption.no;
          break;
        default:
          this.risk.productsSoughtEnableCrossBorderAssetFlows.response = YesNoOption.of(
            this.risk?.productsSoughtEnableCrossBorderAssetFlows?.response?.name
          );
          break;
      }
      switch (this.risk?.productsSoughtEnableCrossBorderAssetFlows?.assessment) {
        case '1':
        case 1:
          this.risk.productsSoughtEnableCrossBorderAssetFlows.assessment = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.productsSoughtEnableCrossBorderAssetFlows.assessment = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.productsSoughtEnableCrossBorderAssetFlows.assessment = LevelOption.high;
          break;
        default:
          this.risk.productsSoughtEnableCrossBorderAssetFlows.assessment = LevelOption.of(
            this.risk?.productsSoughtEnableCrossBorderAssetFlows?.assessment?.name
          );
          break;
      }
    }
    if (_.isEmpty(this.risk?.customerSeekingAnonymity)) {
      this.risk.customerSeekingAnonymity = {
        response: YesNoOption.none,
        assessment: LevelOption.none
      };
    } else {
      switch (this.risk?.customerSeekingAnonymity?.response) {
        case '1':
        case 1:
          this.risk.customerSeekingAnonymity.response = YesNoOption.yes;
          break;
        case '2':
        case 2:
          this.risk.customerSeekingAnonymity.response = YesNoOption.no;
          break;
        default:
          this.risk.customerSeekingAnonymity.response = YesNoOption.of(
            this.risk?.customerSeekingAnonymity?.response?.name
          );
          break;
      }
      switch (this.risk?.customerSeekingAnonymity?.assessment) {
        case '1':
        case 1:
          this.risk.customerSeekingAnonymity.assessment = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.customerSeekingAnonymity.assessment = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.customerSeekingAnonymity.assessment = LevelOption.high;
          break;
        default:
          this.risk.customerSeekingAnonymity.assessment = LevelOption.of(
            this.risk?.customerSeekingAnonymity?.assessment?.name
          );
          break;
      }
    }
    if (_.isEmpty(this.risk?.purposeOfFundsIsNotClearlyDefined)) {
      this.risk.purposeOfFundsIsNotClearlyDefined = {
        response: YesNoOption.none,
        assessment: LevelOption.none
      };
    } else {
      switch (this.risk?.purposeOfFundsIsNotClearlyDefined?.response) {
        case '1':
        case 1:
          this.risk.purposeOfFundsIsNotClearlyDefined.response = YesNoOption.yes;
          break;
        case '2':
        case 2:
          this.risk.purposeOfFundsIsNotClearlyDefined.response = YesNoOption.no;
          break;
        default:
          this.risk.purposeOfFundsIsNotClearlyDefined.response = YesNoOption.of(
            this.risk?.purposeOfFundsIsNotClearlyDefined?.response?.name
          );
          break;
      }
      switch (this.risk?.purposeOfFundsIsNotClearlyDefined?.assessment) {
        case '1':
        case 1:
          this.risk.purposeOfFundsIsNotClearlyDefined.assessment = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.purposeOfFundsIsNotClearlyDefined.assessment = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.purposeOfFundsIsNotClearlyDefined.assessment = LevelOption.high;
          break;
        default:
          this.risk.purposeOfFundsIsNotClearlyDefined.assessment = LevelOption.of(
            this.risk?.purposeOfFundsIsNotClearlyDefined?.assessment?.name
          );
          break;
      }
    }
    if (_.isEmpty(this.risk?.overallRiskScore)) {
      this.risk.overallRiskScore = LevelOption.none;
    } else {
      switch (this.risk?.overallRiskScore) {
        case '1':
        case 1:
          this.risk.overallRiskScore = LevelOption.low;
          break;
        case '2':
        case 2:
          this.risk.overallRiskScore = LevelOption.medium;
          break;
        case '3':
        case 3:
          this.risk.overallRiskScore = LevelOption.high;
          break;
        default:
          this.risk.overallRiskScore = LevelOption.of(this.risk?.overallRiskScore?.name);
          break;
      }
    }
    if (!this.goal.analysis1) {
      this.goal.analysis1 = {
        name: '',
        timeFrame: '',
        estimatedCost: 0
      };
    }
    if (!this.goal.analysis2) {
      this.goal.analysis2 = {
        name: '',
        timeFrame: '',
        estimatedCost: 0
      };
    }
    if (!this.goal.analysis3) {
      this.goal.analysis3 = {
        name: '',
        timeFrame: '',
        estimatedCost: 0
      };
    }
    if (!this.goal.analysis4) {
      this.goal.analysis4 = {
        name: '',
        timeFrame: '',
        estimatedCost: 0
      };
    }
  }

  /*
   * Static Methods
   * --------------------------------------------------------------------------------
   */
  NeedsAnalysis.Blank = function () {
    return NeedsAnalysis.Build({
      risk: {
        natureOfServiceSought: {
          response: 0,
          assessment: LevelOption.none
        },
        productRequired: {
          response: '',
          assessment: LevelOption.none
        },
        internationalTradeFacilitiesBeingSought: {
          response: YesNoOption.none,
          assessment: LevelOption.none
        },
        locationOfUnderlyingAssets: {
          response: 0,
          assessment: LevelOption.none
        },
        locationOfAssetBeingAcquired: {
          response: 0,
          assessment: LevelOption.none
        },
        locationOfFundsForRepayment: {
          response: 0,
          assessment: LevelOption.none
        },
        leadSourcingMethod: {
          response: 0,
          assessment: LevelOption.none
        },
        customerIsDemandingRapidAccess: {
          response: YesNoOption.none,
          assessment: LevelOption.none
        },
        loanRepaymentsComingFromThirdParties: {
          response: YesNoOption.none,
          assessment: LevelOption.none
        },
        productsSoughtEnableCrossBorderAssetFlows: {
          response: YesNoOption.none,
          assessment: LevelOption.none
        },
        customerSeekingAnonymity: {
          response: YesNoOption.none,
          assessment: LevelOption.none
        },
        purposeOfFundsIsNotClearlyDefined: {
          response: YesNoOption.none,
          assessment: LevelOption.none
        },
        overallRiskScore: LevelOption.none
      },
      goal: {
        analysis1: {
          name: '',
          timeFrame: '',
          estimatedCost: 0
        },
        analysis2: {
          name: '',
          timeFrame: '',
          estimatedCost: 0
        },
        analysis3: {
          name: '',
          timeFrame: '',
          estimatedCost: 0
        },
        analysis4: {
          name: '',
          timeFrame: '',
          estimatedCost: 0
        }
      }
    });
  };
  NeedsAnalysis.Build = function (data) {
    return new NeedsAnalysis(data.risk, data.goal);
  };

  return NeedsAnalysis;
};
